import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-template',
  templateUrl: './social-template.component.html',
  styleUrls: ['./social-template.component.scss']
})
export class SocialTemplateComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
